var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGearInArrowCircle = function SvgGearInArrowCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M17.03 13.348c.541-.249.812-.373.891-.497.079-.123.079-.32.079-.712v-.278c0-.393 0-.589-.079-.712-.079-.124-.35-.248-.891-.497-.803-.37-1.319-1.177-1.291-2.023.021-.646.032-.969-.039-1.091-.07-.123-.24-.216-.578-.402l-.323-.177c-.33-.18-.494-.27-.634-.263-.14.006-.38.168-.857.492a2.36 2.36 0 0 1-2.615 0c-.478-.324-.716-.486-.857-.493-.14-.006-.305.084-.634.264l-.323.177c-.339.186-.508.279-.578.401-.07.123-.06.446-.04 1.092.028.846-.488 1.654-1.29 2.023-.542.249-.813.373-.892.497-.079.123-.079.32-.079.712v.278c0 .393 0 .59.079.712.079.124.35.248.891.497.803.37 1.319 1.177 1.291 2.023-.021.646-.032.969.039 1.091.07.123.24.216.579.402l.322.177c.33.18.494.27.634.264s.38-.169.857-.493a2.36 2.36 0 0 1 2.617 0c.477.324.716.486.857.492.14.007.305-.083.634-.263l.322-.177c.34-.186.51-.279.58-.402.07-.122.059-.445.038-1.091-.028-.846.487-1.654 1.29-2.023Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeWidth: 1.5,
    d: "M12 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#807D7D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19 2v2.859A9.97 9.97 0 0 0 12 2C6.477 2 2 6.477 2 12c0 1.422.297 2.775.832 4M5 22v-2.859A9.97 9.97 0 0 0 12 22c5.523 0 10-4.477 10-10a10 10 0 0 0-.832-4"
  })));
};
export default SvgGearInArrowCircle;